module.exports = __webpack_public_path__ + "static/media/al.01225beb.svg";